module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAAVlJREFUOE+1lMFNw0AQRf84kq+kBSogqQCogFAB8SXj3KACoAK4xeuLQwUkFQAVYCqgBXO15B20xrbsje04kdjTSvPn7Wjm7xD2nCAIYiISZp72SakvqJSaAXg1GhGZ+b6/7dK3glar1dxxnCcAYysx0VrfLZfLtQ3cARWQqK9SrbVnwxqgKIrGaZp+t1RicxPXdU89z0vKQAM0pJoy0a6qAVJKPQC43zfJIv7IzEafn/8BBUGwIaKrIRWJyNb3fWOP1oreAZwPAQH4YOaLLpAMhOQyZq5aU13qLj4Ads3Mm0azlVLGrTcHQIz0hZnnFSgMw4mIfB4I+Wsy0XSxWMRUuPkNwOQYEIDYdd1LKtbE2ZGQMi02oMHe6XrMeCqfmulRlmWNlUFEz0QU1wcgIl8iclsHjkajJO9R1yvmAxORmeIPERnjnbStj1ZD2tDiE+fjBbCuf1Jb+wsi74wU1/eCcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tonzhi.png
// module id = /yqY
// module chunks = 97